import React from 'react';
import styled from 'styled-components';
import { Button } from '@lt/components';
import { NoFilterHotelResults } from '@lt/components/icons-react/userflow';

import { useTranslation } from '@lt/localization';

import {
  formatDateToDayWithMonth,
  convertClientDateToServerDate,
} from '../../../../utils/dateUtils';
import type { SearcherFilteredEmptyProps } from './types';

const SearcherFilteredEmpty = ({
  isMobile,
  date,
  onClick,
  isHotelOnly,
}: SearcherFilteredEmptyProps) => {
  const parseDate = convertClientDateToServerDate(date);
  const dateText = formatDateToDayWithMonth(parseDate);
  const { t } = useTranslation();

  return (
    <StyledContainer isMobile={isMobile}>
      <StyledNoFilterHotelResults />
      <StyledHeader isMobile={isMobile}>
        {t('hotel.filteredEmpty.title', {
          context: isHotelOnly ? 'hotel' : 'package',
        })}
        {dateText}
      </StyledHeader>
      {!isHotelOnly ? (
        <StyledText isMobile={isMobile}>
          {t('hotel.filteredEmpty.subtitle')}
        </StyledText>
      ) : null}
      <StyledButton onClick={onClick}>
        {t('filters.clearbutton.desktop')}
      </StyledButton>
    </StyledContainer>
  );
};

const StyledContainer = styled.div<{ isMobile: boolean }>`
  margin: 0 auto;
  padding: ${({ isMobile }) => (isMobile ? '5px 15px 15px' : '50px 0 100px')};
  display: flex;
  width: ${({ isMobile }) => (isMobile ? '300px' : '420px')};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;
const StyledHeader = styled.div<{ isMobile: boolean }>`
  margin-bottom: 8px;
  font-size: ${({ isMobile }) => (isMobile ? '18px' : '22px')};
  font-weight: bold;
  color: ${(props) => props.theme.colors.blackBase};
`;
const StyledText = styled.div<{ isMobile: boolean }>`
  margin-bottom: 10px;
  font-size: ${({ isMobile }) => (isMobile ? '13px' : '14px')};
  text-align: center;
  color: ${(props) => props.theme.colors.blackLight};
`;

const StyledButton = styled(Button)`
  width: 220px;
  font-size: 14px;
`;

const StyledNoFilterHotelResults = styled(NoFilterHotelResults)`
  width: 166px;
`;

export default SearcherFilteredEmpty;
